import React from 'react';

import PropTypes from 'prop-types';
import { Divider, Typography } from '@telus-uds/components-web';

import UserDetailsForm from './components/form';
import { UserDetailsContainer } from '../../css';
import Modal from './modal';

export default function UserDetails({ userData, fetchUsers }) {
  if (!userData) return null;

  const { first_name: firstName, last_name: lastName } = userData;

  return (
    <Modal>
      <UserDetailsContainer>
        <Typography heading="h2" variant={{ size: 'h2' }} block>
          {firstName} {lastName}
        </Typography>
        <Divider />
        <UserDetailsForm userData={userData} fetchUsers={fetchUsers} />
      </UserDetailsContainer>
    </Modal>
  );
}

UserDetails.propTypes = {
  userData: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string
  }).isRequired,
  fetchUsers: PropTypes.func.isRequired
};
